<template>
  <div>
    <TextInputConfiguration
      :controller="OrderStringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <TextInputConfiguration
      :controller="FCStringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
  </div>
</template>

<script>
import {inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'

export default {
  name: 'HPF',
  components:{
    TextInputConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      elementsConfig:[],
      OrderStringCtrller: new inputTextConfCtrller(ConfigName.OrderHPFPreProc,'Order','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0}),
      FCStringCtrller: new inputTextConfCtrller(ConfigName.FCSHPFPreProc,'FC','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0}),
    }
  },
  mounted(){
    this.elementsConfig = [
      this.OrderStringCtrller,
      this.FCStringCtrller
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
}
</script>

<style>
